import Inputmask from 'inputmask';

const MASK = '99/99/9999';
const PLACEHOLDER = 'mm/dd/yyyy';
const INPUT_SELECTOR = '.in-date';
const DATE_PICKER_INPUT_SELECTOR = '.datepicker-autoclose';

const DateInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);
        const $datePickerInputs = $scope.find(DATE_PICKER_INPUT_SELECTOR);

        $datePickerInputs.datepicker({
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
        });

        Inputmask({
            mask: MASK,
            placeholder: PLACEHOLDER,
            showMaskOnHover: false,
        }).mask($inputs);
    },

    destroy: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);
        const $datePickerInputs = $scope.find(DATE_PICKER_INPUT_SELECTOR);

        $datePickerInputs.removeClass('hasDatepicker');
        $('#ui-datepicker-div').remove();
        $datePickerInputs.datepicker('destroy');

        Inputmask.remove($inputs);
    },
};

export default DateInput;
